import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const USER_REVIEW_TRACING_ACTIONS = {
  traceCanReviewResponse: createAction(
    '[NGRXTrace - User Review] Can Review Response',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceSaveUserReviewRequest: createAction(
    '[NGRXTrace - User Review] User review request saved in database',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceRequestUserReview: createAction(
    '[NGRXTrace - User Review] Review requested successfully',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceRequestUserReviewError: createAction(
    '[NGRXTrace - User Review] An error occurred while requesting a review',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
